import './component.scss'

import { Controller } from 'stimulus'

const application = window.Stimulus

application.register(
  'nurikae-site-pages-company-review-partials-sticky-header',
  class extends Controller {
    static targets = ['header']

    connect () {
      this.observer = null

      // 口コミ一覧ページ用のトリガー要素を取得
      this.triggerElement = document.querySelector('.company-review__sp-first-view')

      if (this.triggerElement) {
        this.setupObserver()
      }
    }

    disconnect () {
      if (this.observer) {
        this.observer.disconnect()
      }
    }

    setupObserver () {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
      }

      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), options)
      this.observer.observe(this.triggerElement)
    }

    /**
     * company-review__sp-first-viewが画面内外に移動したときに呼び出されるコールバック
     * @param {IntersectionObserverEntry[]} entries
     */
    handleIntersection (entries) {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          // company-review__sp-first-viewが画面外に出たら表示
          this.showHeader()
        } else {
          // company-review__sp-first-viewが画面内に入ったら非表示
          this.hideHeader()
        }
      })
    }

    showHeader () {
      this.headerTarget.classList.add('company-review-sp-sticky-header--visible')
    }

    hideHeader () {
      this.headerTarget.classList.remove('company-review-sp-sticky-header--visible')
    }
  }
)
